module.exports = __webpack_public_path__ + "static/media/services_med.bb87f623.jpg";